/**
 * Phase 11.3 — Retention event tracking client.
 *
 * Lightweight wrapper around POST /api/retention/event. Failures are
 * intentionally silent — analytics must never break the UI.
 *
 * Phase 11.4: removed the client-side whitelist. The backend already
 * soft-tags unknown events; duplicating the list here caused new event
 * names to be dropped silently when the backend list grew. Single
 * source-of-truth is now `lifted/retention.py::_ALLOWED_EVENTS`.
 */
import api from "@/lib/api";

let _lastFire = 0;
const MIN_INTERVAL_MS = 200; // de-bounce rapid double-fires

function currentParams() {
  if (typeof window === "undefined") return {};
  const p = new URLSearchParams(window.location.search);
  return {
    source:   p.get("source")   || null,
    campaign: p.get("campaign") || null,
  };
}

export function trackEvent(event, meta = {}) {
  if (!event || typeof event !== "string") return;
  const now = Date.now();
  if (now - _lastFire < MIN_INTERVAL_MS) return;
  _lastFire = now;
  const { source, campaign } = currentParams();
  try {
    api.post("/retention/event", {
      event,
      source,
      campaign,
      path:     typeof window !== "undefined" ? window.location.pathname : null,
      referrer: typeof document !== "undefined" ? document.referrer || null : null,
      meta,
    }).catch(() => {});
  } catch (_e) { /* analytics must never throw */ }
}
